const prefix = process.env.NEXT_PUBLIC_BASE_PATH || '';

export const links = {
  START_PROCESS: `${prefix}`,
  SCORING_RESULTS: `${prefix}/spr-decision`,
  SIGN_DOCS: `${prefix}/docs`,
  INCOME_VERIFICATION: `${prefix}`,
  CREDIT_ISSUED: `${prefix}/credit-accept`,
  BIOMETRIC: `${prefix}/biometry`,
  BIOMETRIC_DEFAULT: `${prefix}/biometry-default`,
  ECP_SIGN: `${prefix}/ecp-sign`,
  ECP_CERTEFICATES: `${prefix}/ecp-certificates`,
  ECP_NUC: `${prefix}/ecp/ecp-nuc`,
  ECP_DIGITAL: `${prefix}/ecp/digital-ecp`,
  ACCOUNT: `${prefix}/select-account`,
};

// Маркер в адресе главной страницы: заявка вернулась на шаг INCOME_VERIFICATION
// (например, после подписания согласия КГД) и нужно открыть блок загрузки выписок.
export const UPLOAD_INCOME_DOCS_HASH = "uploadIncomeDocs";
